import type { NegativeNews } from '@gcv/shared';
import type { NegativeNewsReviewStatus, NegativeNewsRiskLevel } from '@gcv/shared';
import { injectable } from 'inversify';

import { banksApi } from './api-util/api';

@injectable()
export class NegativeNewsApi {
  async getNegativeNewsForCrb(sp_id: string, crb_id: string): Promise<NegativeNews[]> {
    const records: NegativeNews[] = await banksApi().get(
      `/banks/${sp_id}/dispensaries/${crb_id}/negative-news`
    );
    return records;
  }

  async getArticleUrl(sp_id: string, crb_id: string, story_id: string): Promise<string> {
    const url: string = await banksApi().get(
      `/banks/${sp_id}/dispensaries/${crb_id}/negative-news/${story_id}/url`
    );
    return url;
  }

  async setRiskLevel(
    source_story_id: string,
    sp_id: string,
    crb_id: string,
    risk_level: NegativeNewsRiskLevel
  ) {
    await banksApi().put(
      `/banks/${sp_id}/dispensaries/${crb_id}/negative-news/${source_story_id}/risk_level/:risk_level`,
      {
        risk_level
      }
    );
  }

  async setReviewStatus(
    source_story_id: string,
    sp_id: string,
    crb_id: string,
    review_status: NegativeNewsReviewStatus,
    review_note: string
  ) {
    await banksApi().put(
      `/banks/${sp_id}/dispensaries/${crb_id}/negative-news/${source_story_id}/review_status/:review_status`,
      {
        review_status,
        review_note
      }
    );
  }
}
